import { ReactNode } from "react";

import { GroupItem } from "../../types";
import { GroupContainer, GroupFieldSetContainer } from "../group-components";

export type SummaryGroupProps = {
  group: GroupItem;
  children?: ReactNode;
};

export type SummaryGroupFieldSetProps = {
  group: GroupItem;
  index: number;
  children?: ReactNode;
};

export const SummaryGroup = ({ group, children }: SummaryGroupProps) => (
  <GroupContainer
    group={group}
    showDescription={false}
    className="bg-white/100"
  >
    {children}
  </GroupContainer>
);

export const SummaryGroupFieldSet = ({
  group,
  index,
  children,
}: SummaryGroupFieldSetProps) => (
  <GroupFieldSetContainer group={group} index={index} className="p-[1.6rem]">
    {children}
  </GroupFieldSetContainer>
);
